import { QueryClient, useMutation, useQuery } from "@tanstack/react-query"
import { MainLoggedInLayout } from "../../components/layouts/main.loggedIn.layout"
import { useContext, useEffect, useMemo, useState } from "react"
import { UserContext } from "../../context/UserContext"
import { Button, Card, CardActions, CardContent, CardHeader, FormControl, FormControlLabel, FormLabel, Grid, List, ListItem, Radio, RadioGroup, TextField, Container, Box, Typography, Divider, Paper } from "@mui/material"
import { PostMedia } from "../../components/post/card/PostMedia"
import { useNavigate, useParams } from "react-router"
import { editEvent, getEvent } from "../../controllers/event/event"
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { CategoryPicker } from "../../components/category.picker"
import Autocomplete from "react-google-autocomplete";
import { getSinglePost } from "../../controllers/posts/posts"
import { editComment } from "../../controllers/posts/comments"
import { header_radio_set } from "../../util/util"
import { Delete, Schedule, LocationOn, Category, Image } from "@mui/icons-material"

export const EditEvent = () => {
    let YOUR_GOOGLE_MAPS_API_KEY = process.env.REACT_APP_YOUR_GOOGLE_MAPS_API_KEY
    const { userDetails } = useContext(UserContext)
    let token = userDetails?.token
    const [header_img, setHeaderImg] = useState('https://storage.googleapis.com/events.makegayfriends.com/event_images/uploads/community-1.jpg')
    const [media_ids, setMediaIds] = useState([])
    const [imageUrls, setImageUrls] = useState([])
    const [chooseHeader, setChooseHeader] = useState(true)
    const [startdate, setStartDate] = useState(new Date())
    const [enddate, setEndDate] = useState(new Date())
    const [category, setCategory] = useState('')
    const [status, setStatus] = useState('')
    const [location, setLocation] = useState('')
    const [isOnline, setIsOnline] = useState(false)
    const [meetingLink, setMeetingLink] = useState('')
    const [title, setTitle] = useState('')
    const [community_id, setCommunityId] = useState('')
    let navigate = useNavigate()
    const { id } = useParams()
    const { data:event, refetch } = useQuery({ queryKey: ['getSingleEvent'], queryFn: () => getEvent(token, id) })
    const { data:content, refetch:refetchPost } = useQuery({ queryKey: ['getSinglePost'], queryFn: () => getSinglePost(single_event.status, token) })

    useEffect(() => {
        refetch()
        refetchPost()
    })

    let single_event = useMemo(() => event?.event ?? {} ,[event?.event])

    const queryClient = new QueryClient()

    const mutationComment = useMutation({
      mutationFn: editComment,
      onSuccess: (data) => {
        // Invalidate and refetch
        console.log(data)
        queryClient.invalidateQueries({ queryKey: ['editComment'] })
        navigate("/event/show/"+single_event?._id)
      },
    })
  
    const send_edit = () => {
        mutationComment.mutate({
        id:single_event?.status,
        body:{
            status,
            media_ids
        },
        token
      })
    }

    const mutation = useMutation({
        mutationFn: editEvent,
        onSuccess: () => {
        // Invalidate and refetch
        queryClient.invalidateQueries({ queryKey: ['editEvent'] })
        send_edit()
        },
    })

    useEffect(() => {
        setTitle(single_event?.title ?? '')
        setStartDate(new Date(single_event?.start_date_time ?? ''))
        setEndDate(new Date(single_event?.end_date_time ?? ''))
        setLocation(single_event?.location ?? '')
        setIsOnline(single_event?.is_online ?? false)
        setMeetingLink(single_event?.meeting_link ?? '')
        setCategory(single_event?.category ?? '')
        setCommunityId(single_event?.community_id ?? null)
        setHeaderImg(single_event?.header_img ?? 'https://storage.googleapis.com/events.makegayfriends.com/event_images/uploads/community-1.jpg')
    }, [single_event])

    useEffect(() => {
      setStatus(content?.content ?? '')
      let img_urls = []
      content?.media_attachments?.filter(item => img_urls.push(item.url))
      setImageUrls(img_urls)
    }, [content])
    
    const sendEditEvent = () => {
        
        mutation.mutate({
          title,
          id:single_event?._id,
          body: {
            desc:status,
            start_date_time:startdate,
            end_date_time:enddate,
            location: isOnline ? undefined : location,
            is_online: isOnline,
            meeting_link: isOnline ? meetingLink : undefined,
            category,
            status:single_event?.status,
            header_img,
            community:community_id,
            author:userDetails?.id,
          },
          token:userDetails?.token
        })
    }

    return (
        <MainLoggedInLayout>
            <Container maxWidth="lg" sx={{ py: 3 }}>
                <Card sx={{ 
                    borderRadius: 3,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
                }}>
                    <CardHeader 
                        title={
                            <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                                Edit Event
                            </Typography>
                        }
                        subheader={
                            <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
                                Update your event details and settings
                            </Typography>
                        }
                        action={
                            <Button 
                                variant="outlined" 
                                color="error" 
                                startIcon={<Delete />}
                                onClick={() => navigate("/event/delete/"+single_event?._id)}
                                sx={{ 
                                    borderRadius: 2,
                                    textTransform: 'none',
                                    fontWeight: 'bold'
                                }}
                            >
                                Delete Event
                            </Button>
                        }
                        sx={{ pb: 1 }}
                    />
                    
                    <CardContent sx={{ p: 4 }}>
                        <Grid container spacing={4}>
                            {/* Basic Information */}
                            <Grid item xs={12}>
                                <Paper sx={{ p: 3, borderRadius: 2, backgroundColor: '#f8f9fa' }}>
                                    <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                                        Basic Information
                                    </Typography>
                                    <TextField 
                                        fullWidth 
                                        value={title} 
                                        onChange={(e) => setTitle(e.target.value)} 
                                        label="Event Title" 
                                        variant="outlined"
                                        sx={{ mb: 2 }}
                                    />
                                </Paper>
                            </Grid>

                            {/* Event Image */}
                            <Grid item xs={12}>
                                <Paper sx={{ p: 3, borderRadius: 2, backgroundColor: '#f8f9fa' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                        <Image sx={{ mr: 1, color: 'primary.main' }} />
                                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                            Event Image
                                        </Typography>
                                    </Box>
                                    
                                    <Box sx={{ mb: 3 }}>
                                        <img 
                                            src={header_img} 
                                            alt={single_event?.title} 
                                            style={{ 
                                                width: '100%', 
                                                maxHeight: '300px', 
                                                objectFit: 'cover',
                                                borderRadius: '8px'
                                            }} 
                                        />
                                    </Box>

                                    <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                                        <Button 
                                            variant={chooseHeader ? "contained" : "outlined"}
                                            onClick={() => setChooseHeader(true)}
                                            sx={{ textTransform: 'none' }}
                                        >
                                            Choose from Gallery
                                        </Button>
                                        <Button 
                                            variant={!chooseHeader ? "contained" : "outlined"}
                                            onClick={() => setChooseHeader(false)}
                                            sx={{ textTransform: 'none' }}
                                        >
                                            Upload New Image
                                        </Button>
                                    </Box>

                                    {chooseHeader ? (
                                        <FormControl sx={{ width: '100%' }}>
                                            <FormLabel sx={{ mb: 2, fontWeight: 'bold' }}>Choose Event Image</FormLabel>
                                            <RadioGroup
                                                value={header_img}
                                                onChange={(e) => setHeaderImg(e.target.value)}
                                            >
                                                <Grid container spacing={2}>
                                                    {header_radio_set.map((radio, index) => (
                                                        <Grid item xs={6} sm={4} md={3} key={index}>
                                                            <FormControlLabel 
                                                                value={`https://storage.googleapis.com/events.makegayfriends.com/event_images/uploads/${radio}`} 
                                                                control={<Radio />} 
                                                                label={
                                                                    <img 
                                                                        alt="community pics" 
                                                                        src={`https://storage.googleapis.com/events.makegayfriends.com/event_images/uploads/${radio}`} 
                                                                        style={{ 
                                                                            width: '100%', 
                                                                            height: '80px', 
                                                                            objectFit: 'cover',
                                                                            borderRadius: '4px'
                                                                        }} 
                                                                    />
                                                                } 
                                                                sx={{ margin: 0 }}
                                                            />
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </RadioGroup>
                                        </FormControl>
                                    ) : (
                                        <Box>
                                            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>
                                                Upload Event Image
                                            </Typography>
                                            <PostMedia 
                                                imageUrls={imageUrls} 
                                                setImageUrls={setImageUrls} 
                                                media_ids={media_ids} 
                                                setMediaIds={setMediaIds} 
                                                token={userDetails?.token} 
                                            />
                                        </Box>
                                    )}
                                </Paper>
                            </Grid>

                            {/* Date and Time */}
                            <Grid item xs={12}>
                                <Paper sx={{ p: 3, borderRadius: 2, backgroundColor: '#f8f9fa' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                                        <Schedule sx={{ mr: 1, color: 'primary.main' }} />
                                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                            Date & Time
                                        </Typography>
                                    </Box>
                                    
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={6}>
                                            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>
                                                Start Date & Time
                                            </Typography>
                                            <Box sx={{ '& .rdtPicker': { borderRadius: 2 } }}>
                                                <Datetime 
                                                    value={startdate} 
                                                    onChange={(value) => setStartDate(value._d)} 
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>
                                                End Date & Time
                                            </Typography>
                                            <Box sx={{ '& .rdtPicker': { borderRadius: 2 } }}>
                                                <Datetime 
                                                    value={enddate} 
                                                    onChange={(value) => setEndDate(value._d)} 
                                                />
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>

                            {/* Location */}
                            <Grid item xs={12}>
                                <Paper sx={{ p: 3, borderRadius: 2, backgroundColor: '#f8f9fa' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                        <LocationOn sx={{ mr: 1, color: 'primary.main' }} />
                                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                            Location
                                        </Typography>
                                    </Box>

                                    <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                                        <Button
                                            variant={!isOnline ? "contained" : "outlined"}
                                            onClick={() => setIsOnline(false)}
                                            size="small"
                                        >
                                            In Person
                                        </Button>
                                        <Button
                                            variant={isOnline ? "contained" : "outlined"}
                                            onClick={() => setIsOnline(true)}
                                            size="small"
                                        >
                                            Online
                                        </Button>
                                    </Box>

                                    {isOnline ? (
                                        <TextField
                                            fullWidth
                                            label="Meeting Link (optional)"
                                            placeholder="Paste your Zoom/Meet/call link"
                                            value={meetingLink}
                                            onChange={(e) => setMeetingLink(e.target.value)}
                                            helperText="Optional — attendees can also just check in once the party starts to link up."
                                            variant="outlined"
                                        />
                                    ) : (
                                        <Autocomplete
                                            className="form-control"
                                            apiKey={YOUR_GOOGLE_MAPS_API_KEY}
                                            onPlaceSelected={(place) => setLocation(place)}
                                            defaultValue={location?.formatted_address}
                                            style={{
                                                width: '100%',
                                                padding: '12px 16px',
                                                border: '1px solid #ccc',
                                                borderRadius: '8px',
                                                fontSize: '16px'
                                            }}
                                        />
                                    )}
                                </Paper>
                            </Grid>

                            {/* Description */}
                            <Grid item xs={12}>
                                <Paper sx={{ p: 3, borderRadius: 2, backgroundColor: '#f8f9fa' }}>
                                    <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                                        Event Description
                                    </Typography>
                                    
                                    {status && (
                                        <Box sx={{ 
                                            p: 2, 
                                            mb: 2, 
                                            backgroundColor: 'white', 
                                            borderRadius: 1,
                                            border: '1px solid #e0e0e0'
                                        }}>
                                            <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary' }}>
                                                Current Description:
                                            </Typography>
                                            <div dangerouslySetInnerHTML={{__html: status }} />
                                        </Box>
                                    )}
                                    
                                    <TextField 
                                        placeholder="Update Description" 
                                        onChange={(e) => setStatus(e.target.value)} 
                                        fullWidth 
                                        multiline 
                                        rows={4}
                                        label='Update Description' 
                                        variant="outlined"
                                        sx={{ mb: 2 }}
                                    />
                                    <PostMedia 
                                        imageUrls={imageUrls} 
                                        setImageUrls={setImageUrls} 
                                        media_ids={media_ids} 
                                        setMediaIds={setMediaIds} 
                                        token={token} 
                                    />
                                </Paper>
                            </Grid>

                            {/* Category */}
                            <Grid item xs={12}>
                                <Paper sx={{ p: 3, borderRadius: 2, backgroundColor: '#f8f9fa' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                        <Category sx={{ mr: 1, color: 'primary.main' }} />
                                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                            Category
                                        </Typography>
                                    </Box>
                                    <CategoryPicker category={category} setCategory={setCategory} />
                                </Paper>
                            </Grid>
                        </Grid>
                    </CardContent>
                    
                    <Divider />
                    
                    <CardActions sx={{ p: 3 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <Button 
                                    fullWidth 
                                    variant="outlined" 
                                    onClick={() => navigate("/event/show/"+single_event?._id)}
                                    sx={{ 
                                        py: 1.5,
                                        borderRadius: 2,
                                        textTransform: 'none',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Button 
                                    fullWidth 
                                    variant="contained" 
                                    onClick={sendEditEvent}
                                    sx={{ 
                                        py: 1.5,
                                        borderRadius: 2,
                                        textTransform: 'none',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    Update Event
                                </Button>
                            </Grid>
                        </Grid>
                    </CardActions>
                </Card>
            </Container>
        </MainLoggedInLayout>
    )
}